// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"PageContent_backgroundImage__u_WTe"};